export function getBetInputPlaceholder(stepBet: number): string {
  return stepBet === 1 ? 'Введите ставку' : `Должна быть кратна ${stepBet}`;
}
